import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import AuthGuard from '@/components/auth-guard';
import { EntitySettingsView } from '@/components/entity-settings/entity-settings-view';

export const Route = createFileRoute('/events/settings')({
  component: EventSettingsPage,
});

function EventSettingsPage() {
  return (
    <AuthGuard>
      <Suspense fallback={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
          <CircularProgress size={32} />
        </Box>
      }>
        <EntitySettingsView
          type="events"
          title="Event Profile Settings"
          breadcrumbLabel="Events"
          breadcrumbLink="/events"
        />
      </Suspense>
    </AuthGuard>
  );
}
